/** Смещение ряда в «шагах» (умножить на stepY). [index][rowIndex] */
const ROW_DELTAS: ReadonlyArray<readonly number[]> = [
  [0, 0, 0, 0],
  [0, 0, 1, -1],
  [0, 1, 1, -2],
  [1, 1, 1, -3],
];

/** translateY в пикселях для всех 4 рядов при данном index. */
export function getRowTranslates(index: number, stepY: number): number[] {
  const safe = Math.min(3, Math.max(0, index));

  return ROW_DELTAS[safe].map(d => d * stepY);
}
